// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import {
  CreateTenantFromTemplateRequest,
  Practice as NextgenPractice,
  TCCService,
  Template,
  Tenant,
} from '@/services/tcc/configurator'

export type { NextgenPractice, Template, Tenant }

export const getTenant = async (tenantId: string) => {
  return TCCService.GetTenant({ tenantId })
}

export const refreshPractice = async (practiceId: string) => {
  return TCCService.RefreshPractice({ practiceId })
}

export const getTemplates = async () => {
  const data = await TCCService.GetTemplates({ deployable: false })
  return data.templates as Template[]
}

export const createTenantFromTemplate = async (
  request: CreateTenantFromTemplateRequest
) => {
  return TCCService.CreateTenantFromTemplate(request)
}

export const getNextgenPractices = async ({
  gcn,
  practiceName = '',
}: {
  gcn: string
  practiceName?: string
}): Promise<NextgenPractice[]> => {
  const resp = await TCCService.GetNextgenPractices({
    practiceId: '',
    practiceName,
    gcn,
  })

  return resp.practices ?? []
}

export const sortActiveAndArchivedTenants = (tenants: Tenant[]) => {
  const sortedTenants = [...tenants].sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  )

  return {
    activeTenants: sortedTenants.filter((tenant) => !tenant.archived),
    archivedTenants: sortedTenants.filter((tenant) => tenant.archived),
  }
}
